import { useSiteContent } from "@/context/SiteContentContext";
import { Radio } from "lucide-react";

export default function LiveHero() {
  const { t } = useSiteContent();
  if (t("live.hero.visible", "true") === "false") return null;
  const bg = t("live.hero.bg", "#FEF3E6");
  const image = t("live.hero.image", "");
  const ctaText = t("live.hero.cta_text", "Shop live now");
  const ctaLink = t("live.hero.cta_link", "#live-vendors");
  return (
    <section data-testid="live-hero" className="mx-auto max-w-7xl px-4 lg:px-8 mt-3 sm:mt-6">
      <div className="rounded-3xl overflow-hidden relative" style={{ background: bg }}>
        {image && <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />}
        <div className="relative p-6 sm:p-10 md:p-14">
          <div className="inline-flex items-center gap-2 text-[10px] sm:text-xs uppercase tracking-[0.25em] font-bold text-red-600 mb-3">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-600" />
            </span>
            {t("live.hero.kicker", "CityShor Live")}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl mb-3 max-w-2xl">{t("live.hero.headline", "Live Exhibitor Showcases")}</h2>
          <p className="text-gray-700 max-w-xl text-sm sm:text-base mb-6">{t("live.hero.subtext", "Exhibitors go live with curated picks for a limited window. Shop them before the timer runs out.")}</p>
          <a data-testid="live-hero-cta" href={ctaLink} className="inline-flex items-center gap-2 rounded-full bg-[#111827] text-white px-6 h-11 text-sm font-medium hover:bg-black transition-colors">
            <Radio className="h-4 w-4" /> {ctaText}
          </a>
        </div>
      </div>
    </section>
  );
}
